import { Box, ListItemText, Typography } from "@mui/material";
import type { InboxCategoryTags } from "../../../../store/state/inboxStructure/types";
import DynamicIcon from "@entrilia/shared/components/DynamicIcon";
import Item from "./Item";

interface Props {
  selectedItem: string;
  item: InboxCategoryTags;
  onClick: () => void;
}

export const CategoryItem = (props: Props) => {
  const { item, onClick, selectedItem } = props;
  return (
    <Item item={item.name} selectedItem={selectedItem} onClick={onClick}>
      <Box sx={{ display: "flex", alignItems: "center", width: 20, flexShrink: 0 }}>
        {item.iconCode && <DynamicIcon iconName={item.iconCode} />}
      </Box>
      <ListItemText>
        <Typography variant="subtitle2" sx={{ pl: 1 }}>
          {item.name}
        </Typography>
      </ListItemText>
    </Item>
  );
};
export default CategoryItem;
